import React, { useContext, useEffect, useState } from "react";
import {
    Button, CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery, useTheme
} from "@material-ui/core";

import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/generalMenuStore/forms";
import { changeEventHandlerDecorator, localize } from "../../../../../common/libs";
import useCheckAliasesAvailability from "../../../../../hooks/useCheckAliasesAvailability";
import { TextField, Typography } from "../../../../../common/components/libs";
import { locale } from "../../../../../common/consts";
import { trackCreateAlias } from "../../../../utils/MetrikaService";
import { Trans, useTranslation } from "react-i18next";
import generalMenuStore from "../../../store/generalMenuStore";


const AddAliasForm = () => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const {t} = useTranslation(["general", "menu"]);
    const [alias, setAlias] = useState("");

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const { generalMenuStore, authStore } = useStores();
    const [available, isAliasCheckLoading, validationErr, setAliasToCheck] = useCheckAliasesAvailability();
    const { current, open, menuId, notify } = generalMenuStore.forms.forms[MenuFormType.editAlias];

    useEffect(() => {
        setAlias(current && current.alias || "");
        setTitle(current && localize(current.data.title) || "");
        setDescription(current && localize(current.data.description) || "");
    }, [current]);

    useEffect(() => {
        setAliasToCheck(alias);
    }, [alias]);


    const closeForm = () => {
        generalMenuStore.forms.closeForm(MenuFormType.editAlias);
    };

    const handleSubmit = async () => {
        if (alias.length < 5) {
            return;
        }
        if (isAliasCheckLoading || !available) return;
        const data = {
            alias,
            title: {
                [locale]: title
            },
            description: {
                [locale]: title
            },
            photosUrls: [],
            aliasedMenus: [
                {
                    menuId: menuId,
                    organizationBranchId: authStore.currentUser.organizationData.organizationBranchId,
                    organizationId: authStore.currentUser.organizationData.organizationId
                }
            ]
        };
        if (current) {
            await generalMenuStore.updateAlias(data);
        } else {
            await generalMenuStore.createAlias(data);
            await generalMenuStore.fetchMenus();
            await generalMenuStore.fetchMenus();
            trackCreateAlias();
        }
        if (notify) notify();
        closeForm();
    };

    let dialogTitle;
    if (current) {
        dialogTitle = t("menu:orderSettingsPage.editLink");
    } else {
        dialogTitle = t("menu:orderSettingsPage.creationLink");
    }

    const getPublicMenuUrl = () => {
        return `https://menu.restify.one/`;
    };

    const getHelperText = () => {
        let res = t("menu:orderSettingsPage.regularExpresion");
        if (isAliasCheckLoading || validationErr || alias.length < 5) return res;

        if (!available) {
            return <Trans i18nKey="menu:orderSettingsPage.aliasBusy" values={{alias: alias}}/>
        }
        return res;
    };

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {dialogTitle}
            </DialogTitle>
            <DialogContent>
                <form autoComplete="off">
                    <TextField
                        label={t("menu:orderSettingsPage.alias")}
                        helperText={getHelperText()}
                        error={(validationErr || !available) && alias.length > 4}
                        fullWidth={true}
                        InputProps={{
                            endAdornment: isAliasCheckLoading && <div>
                              <CircularProgress size={20} color="secondary"/>
                            </div>
                        }}
                        value={alias}
                        onChange={changeEventHandlerDecorator(setAlias)}
                    >
                    </TextField>
                    <Typography variant={'body2'}>
                        <Typography variant={'caption'}>
                            {t("menu:orderSettingsPage.menuWillAvailableAtLink")}
                        </Typography> <br/>
                        <Typography color={'primary'}>
                            {getPublicMenuUrl()}{alias}
                        </Typography>
                    </Typography>
                    <TextField
                        my={3}
                        label={t("general:name")}
                        fullWidth={true}
                        value={title}
                        onChange={changeEventHandlerDecorator(setTitle)}
                    />
                    <TextField
                        my={3}
                        label={t("general:description")}
                        fullWidth={true}
                        value={description}
                        onChange={changeEventHandlerDecorator(setDescription)}
                    />

                </form>
            </DialogContent>

            <DialogActions>
                <Button onClick={closeForm} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                    variant={'contained'}
                    disabled={!(available && !isAliasCheckLoading)}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default observer(AddAliasForm);
